<template>
	<h1
		class="flex flex-wrap justify-center gap-3 text-center text-5xl font-cinema lg:text-7xl md:text-6xl">
		<span>دستیار</span>

		<span class="text-primary">هوشمند</span>

		<span>فارسی</span>
	</h1>
</template>
